module.exports = __webpack_public_path__ + "images/sprites/ui/icon_ranking_bronze_123c4d7c2b8e5271a569f622d6996402.png";